import * as React from 'react';
import { connect } from 'react-redux';
import { Button, Modal, Grid } from 'semantic-ui-react';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';
import { requestExportDatapayHolidayDays } from 'services/timesheets/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import { makeSelectQueryStringBooleanValue } from 'workspaces/react-router-selectors';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import SubmittingButton from 'components/SubmittingButton';
// @ts-ignore
import ErrorAlert from 'components/ErrorAlert';

// Selectors
import { makeSelectDateRange } from './selectors';

// Constants
const NAMESPACE = 'DATAPAY_HOLIDAY_DAYS_EXPORT';

// Types
interface DispatchProps {
    requestExportDatapayHolidayDays: typeof requestExportDatapayHolidayDays;
    updateQueryString: typeof updateQueryString;
}

interface ConnectedProps {
    open: boolean;
    error?: string;
    dateRange: { firstDate: string; lastDate: string };
}

type Props = DispatchProps & ConnectedProps;

export class ExportTimesheetsModal extends React.PureComponent<Props> {
    handleDatapayHolidayDaysExport = (): void => {
        this.props.requestExportDatapayHolidayDays();
    };

    handleClose = (): void => {
        this.props.updateQueryString({
            exportTimesheetsModal: undefined
        });
    };

    render(): React.ReactElement {
        const { open, dateRange } = this.props;

        return (
            <Modal
                open={open}
                onClose={this.handleClose}
                size="tiny"
                centered={false}
                closeIcon
            >
                <ErrorBoundary
                    namespace="exportTimesheetsModal"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <Modal.Header>Export</Modal.Header>
                    <Modal.Content>
                        <p>
                            Export Datapay Holiday Days for (
                            {dateRange.firstDate} - {dateRange.lastDate}):
                        </p>
                        <ErrorAlert namespace={NAMESPACE} />
                        <Grid>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Button
                                    type="button"
                                    onClick={(): void => {
                                        this.handleClose();
                                    }}
                                    fluid
                                    basic
                                    primary
                                >
                                    Cancel
                                </Button>
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <SubmittingButton
                                    type="button"
                                    primary
                                    namespace={NAMESPACE}
                                    onClick={
                                        this.handleDatapayHolidayDaysExport
                                    }
                                    fluid
                                >
                                    Export
                                </SubmittingButton>
                            </Grid.Column>
                        </Grid>
                    </Modal.Content>
                </ErrorBoundary>
            </Modal>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    open: makeSelectQueryStringBooleanValue('exportTimesheetsModal'),
    dateRange: makeSelectDateRange()
});

export default connect(mapStateToProps, {
    updateQueryString,
    requestExportDatapayHolidayDays
})(ExportTimesheetsModal);
